'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/minutesAgo.js
// module id = 573
// module chunks = 0